<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div class="form-group row">
            <label for="" class="col-lg-2 font-weight-bold">Branch</label>
            <div class="col-lg-6">
              <select name="branch" id="branch" v-model="branch" class="custom-select custom-select-sm">
                <option v-for="bran in branchs" :value="bran.id" :key="bran.id">{{bran.name}}</option>
              </select>
              <span class="text-danger" v-if="!branch && isSubmit">
                Please Select Branch
              </span>
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-lg-2 font-weight-bold">Periode</label>
            <div class="col-lg-6">
              <date-picker v-model="year" lang="en" format="YYYY" type="year" not-before="2019-01-01"></date-picker>
            </div>
          </div>
          <div>
            <button class="btn btn-primary" @click="submit()">Submit</button>
          </div>
          <br>
          <br>
          <b-row>
            <div class="table-responsive table-area">
              <table class="table table-bordered responsive-table" v-if="listMetric.length > 0">
                <thead>
                <tr>
                  <th >No</th>
                  <th style="min-width: 400px">Detail</th>
                  <th v-for="(month, i) in months" style="text-align: center">{{month}}</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(dataMetric, i) in listMetric">
                  <tr>
                    <td>{{i + 1}}</td>
                    <td>{{dataMetric.name}}</td>
                  <template v-for="(month, indeks) in months">
                  <td align="center">
                    <template v-if="dataMetric.detail == 1">
                      <a :href="dataMetric.detail_down[indeks] | getHref('down')">
                        {{ dataMetric.month[indeks] }}
                      </a>
                    </template>
                    <template v-else-if="dataMetric.detail == 2">
                      <a :href="dataMetric.detail_down[indeks] | getHref('count')">
                        {{ dataMetric.month[indeks] }}
                      </a>
                    </template>
                    <template v-else-if="dataMetric.detail == 4 " >
                      <a :href="dataMetric.detail_down[indeks] | getHref('down')">
                        {{ dataMetric.month[indeks] | convertMttrTime }}
                      </a>
                    </template>
                    <template v-else>
                      {{ dataMetric.month[indeks] }}
                    </template>
                  </td>
                </template>
                  </tr>
                </template>
                <template v-if="dataFromKPIHelpdesk.length > 0">
                  <tr v-for="(dataKPI, indeks) in dataFromKPIHelpdesk">
                    <td>{{indeks  + listMetric.length + 1}}</td>
                    <td >{{dataKPI.name}}</td>
                    <template v-for="(month, i) in months">
                      <template v-if="indeks == 4">
                        <td align="center">{{dataKPI.month[i] | convertTimetoClock}}</td>
                      </template>
                      <template v-else-if="indeks == 3">
                        <td align="center">
                          <metric-call-href :dataCall="dataFromKPIHelpdesk"
                                            :keys="indeks"
                                            :month="i"
                          />
                        </td>
                      </template>
                      <template v-else>
                        <td align="center" >
                          <template v-if="dataKPI.month[i]">
                            <metric-call-href :linked="dataKPI.month[i].toString()"
                                              :keys="indeks"
                                              :month="i"
                            />
                          </template>
                          </td>
                      </template>
                    </template>
                  </tr>
                </template>
                <template v-if="loading">
                  <tr>
                    <td colspan="14">
                      <div style="text-align: center" v-if="loading">
                        <pulse-loader :size="'12px'"></pulse-loader>
                      </div>
                    </td>
                  </tr>
                </template>

                </tbody>
              </table>

            </div>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import data from '@/component/data'
  import {getService} from "../../../services";
  import DatePicker from 'vue2-datepicker'
  import PulseLoader from 'vue-spinner/src/PulseLoader'
  import moment from 'moment'
  import metricCallHref from './detailMetric/metricCallHref'
  export default {
    components: {
      DatePicker,
      PulseLoader,
      metricCallHref
    },
    data() {
      return {
        isSubmit: false,
        year: moment(),
        months: data.month3Letter,
        idVendor: [],
        listMetric: [],
        loading: false,
        branch: '',
        branchs: [],
        checkBranch: '',
        dataFromKPIHelpdesk: []
      }
    },
    created: function () {
      // this.getListVendor();
      this.getBranch()
      var that = this
      if (this.$store.getters.branchinMetric) {
        this.branch = this.$store.getters.branchinMetric
      } else {
        this.checkBranch = setInterval(() => {
          that.branch =  that.$store.getters.branch
          if (that.branch) {
            clearInterval(that.checkBranch)
          }
        }, 1000);
      }
      if(this.$store.getters.listMetric.length > 0) {
        this.listMetric = this.$store.getters.listMetric
      }
      if(this.$store.getters.listMericInKPIHelpdesk.length > 0) {
        this.dataFromKPIHelpdesk = this.$store.getters.listMericInKPIHelpdesk
      }

    },
    methods: {
      submit: function() {
        this.isSubmit = true
        if(!this.branch) {
          return false
        }
        this.$store.commit('changeListMetricOnKPIHelpesek', [])
        this.listMetric = [];
        this.getListVendor();
        this.dataFromKPIHelpdesk = []
        this.$store.commit('changeBranchinMetric', this.branch)
      },
      getListVendor: function () {
        this.$store.commit('noLoad', true)
        getService.list_vendor_with_branch(this.branch)
          .then(
            data=> {
              let dataPush = [];
              for(let i in data) {
                if (data.hasOwnProperty(i)) {
                  dataPush.push(data[i].id)
                }
              }
              this.idVendor = dataPush;
               this.getListMetric(0);
            }
          )
      },
      getListMetric: function (indeks) {
        let idVendor, year, month, branch;
        if(this.idVendor[indeks]) {
          this.loading = true
          year = moment(this.year, 'x').format('YYYY');
          idVendor = this.idVendor[indeks];
          month = 0;
          getService.list_metric_vendor(idVendor, year, month, this.branch)
            .then( data => {
              this.$store.commit('noLoad', false)
              this.loading = false
              const vendor = data.vendor_name
              let monthData
              let dataMetric = []
              let firstData = true
              let index = 0
              for (let i in data.data){
                if (data.data.hasOwnProperty(i)) {
                  monthData = data.data[i]
                  if (firstData) {
                    for (let point in monthData) {
                      if (monthData.hasOwnProperty(point)) {
                        if(typeof monthData[point] ==  'object') {
                          const detailMetricJumlah= {
                            'name' : vendor + ', jumlah ' + point,
                            'month': [monthData[point].total_vendor],
                            'detail_down': [monthData[point].detail_total_vendor],
                            'detail': 2
                          }
                          const detailMetricDown = {
                            'name': vendor + ', total Down ' + point,
                            'month': [monthData[point].total_down],
                            'detail_down': [monthData[point].detail_down],
                            'detail': 1
                          }
                          const detailRasioMetric = {
                            'name': vendor + ', ratio down ' + point,
                            'month': [monthData[point].rasio + '%'],
                            'detail': 3
                          }
                          const mmtrMetric = {
                            'name': vendor + ', MTTR ( Mean Time to Recover ), ' + point,
                            'month': [monthData[point].mttr],
                            'detail_down': [monthData[point].detail_down],
                            'detail': 4
                          }
                          dataMetric.push(detailMetricJumlah)
                          dataMetric.push(detailMetricDown)
                          dataMetric.push(detailRasioMetric)
                          dataMetric.push(mmtrMetric)
                        }
                      }
                    }
                    firstData = false
                  } else {
                    // masukkan kedua
                    index = 0;
                    for (let point in monthData) {
                      if (monthData.hasOwnProperty(point)) {
                        if (typeof monthData[point] == 'object') {
                          dataMetric[index].month.push(monthData[point].total_vendor)
                          dataMetric[index].detail_down.push(monthData[point].detail_total_vendor)
                          dataMetric[index + 1].month.push(monthData[point].total_down)
                          dataMetric[index + 1].detail_down.push(monthData[point].detail_down)
                          dataMetric[index + 2].month.push(monthData[point].rasio + '%')
                          dataMetric[index + 3].month.push(monthData[point].mttr)
                          dataMetric[index + 3].detail_down.push(monthData[point].detail_down)
                          index = 4
                        }
                      }
                    }
                    // console.log(monthData)
                      // dataMetric[j].month.push(monthData[point].rasio)
                  }

                }
              }
              for (let i in dataMetric) {
                this.listMetric.push(dataMetric[i])
              }

              this.getListMetric(indeks + 1)
            })
        } else {
          this.$store.commit('changeListMetric', this.listMetric)
          // sudah berakhir pada list metric
          if (this.branch == '020') {
            this.loading = true
            this.getFromKPI()
          }
        }
      },
      async getBranch() {
        try {
          await getService.list_branch()
            .then(data => {
              this.branchs = data
            })
        } catch (error) {
          // bila data tidak terpanggil
        }
      },
      async getFromKPI() {
        try {
          var date = new Date()
          let month = date.getMonth() + 1
          await getService.show_detail_kpi_helpdesk_all(month)
            .then(data => {
              this.loading = false
              let customerCall = []
              let answeredCall = []
              let noAnswer = []
              let persentaseAnswer = []
              let AverageAnswer = []

              for (let i = 0; i < 7 ; i++) {
                customerCall.push(0)
                answeredCall.push(0)
                noAnswer.push(0)
                persentaseAnswer.push(0)
                AverageAnswer.push(0)
              }
              const det = data.details[2].permformance_key[15].value
              for(let key in det) {
                if(det.hasOwnProperty(key)) {
                  const index = det[key].index
                  customerCall[index] =  det[key].total_detail.data.call
                  answeredCall[index] = det[key].total_detail.data.answer
                  persentaseAnswer[index] = det[key].total + '%'
                  noAnswer[index] = det[key].total_detail.data.call - det[key].total_detail.data.answer
                }
              }

              const averageTime = data.details[1].permformance_key[9].value
              for (let key in averageTime) {
                if (averageTime.hasOwnProperty(key)) {
                  const index = det[key].index
                  AverageAnswer[index] = averageTime[key].total
                }
              }
              const dataKPI = [
                {
                'name': 'Customer Calls',
                'month': customerCall
                },
                {
                  'name': 'Answered Calls',
                  'month': answeredCall
                },
                {
                  'name': 'No Answer (time Out) / Missed Call',
                  'month': noAnswer
                },
                {
                  'name': 'Persentase Answer',
                  'month': persentaseAnswer
                },
                {
                  'name': 'Average Answer Time',
                  'month': AverageAnswer
                }
              ]
              this.dataFromKPIHelpdesk = dataKPI
              this.$store.commit('changeListMetricOnKPIHelpesek', dataKPI)
            })
        } catch (error) {
          // bila data tidak terpanggil
        }
      }

    },
    filters: {
      getHref: function (href, data) {
        if(href) {
          let item, url
          item = href.split('/', 11);
          url = '#/helpdesk/metric/detail-downtime?branch=' + item[6] +
            '&vendor=' + item[7] +
            '&year=' + item[8] +
            '&month=' + item[9] +
            '&type=' + item[10]
          if(data == 'down') {
            return url + '&mode=0'
          } else if(data == 'count') {
            return url + '&mode=1'
          }
        }
      },
      convertMttrTime(value) {
          if (!value) return '-';
          if (value < 0) return value;
          const secondsInDay = 86400;
          if (value >= secondsInDay) {
            const days = Math.floor(value / secondsInDay);
            return `${days} hari`;
          }
          const duration = moment.duration(value, 'seconds');
          const hours = Math.floor(duration.asHours());
          const minutes = duration.minutes();
          const seconds = duration.seconds();
          return `${hours} jam ${minutes} menit ${seconds} detik`;
      },
    }
  }
</script>
<style scoped>

</style>
